import { TextField } from '@mui/material'

const Input = ({ formData, handleChange, inputProps, ...rest }) => {
  const { type, ...formDataWithoutType } = formData || {}

  return (
    <TextField
      {...formDataWithoutType}
      variant="outlined"
      type={type || 'text'}
      onChange={handleChange}
      inputProps={inputProps}
      {...rest}
      autoComplete="off"
    />
  )
}

export { Input }
